/**
 * Fonts
 */
export const standardFontFamily = "'Proxima Nova', 'Helvetica Neue', Helvetica, Arial, sans-serif"
export const condensedFontFamily = "'Proxima Nova Condensed', 'Helvetica Neue', Helvetica, Arial, sans-serif"
export const weightSemiBold = 600
export const weightRegular = 400
export const weightMedium = 500
